/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link } from "react-router";
import { useParams } from "@/commons/hooks/useParams"
import { HeaderContext } from "@/commons/components"
import { useSearchParams } from "react-router";
import { useAuth } from '@/commons/auth';
import FormTambahKelas from '../components/FormTambahKelas'

import getMataKuliah from '../services/getMataKuliah'
import getSemester from '../services/getSemester'
const TambahKelasPage = props => {
const { checkPermission } = useAuth();

	const [isLoading, setIsLoading] = useState({
	tambahKelas: false,

	});
	const { setTitle } = useContext(HeaderContext);

const [mataKuliah, setMataKuliah] = useState()
const [semester, setSemester] = useState()

useEffect(() => {
    const fetch = async () => {
	  setIsLoading(prev => ({...prev, tambahKelas: true}))
		const { data: mataKuliahResponse } = await getMataKuliah({  })
		const { data: semesterResponse } = await getSemester({  })

	    setMataKuliah(mataKuliahResponse.data)
	    setSemester(semesterResponse.data)


	    setIsLoading(prev => ({...prev, tambahKelas: false}))
    }
	if (checkPermission("CreateKelas")) { 
		fetch()
	}
  }, [])

	
	useEffect(() => {
		setTitle("Tambah Kelas Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<Layouts.ViewContainerBackButtonLayout>
			  	<Link to={`/kelas
			  	`}>
			  		<Button id="_SrkxAJxCEe-ejYgMQj2CMA" className="p-4" variant="secondary">
			  		  Kembali
			  		</Button>
			  	</Link>
			  	
			  	
			  </Layouts.ViewContainerBackButtonLayout>
			</>
		}
	>
{ checkPermission("CreateKelas") && ( 
	<Layouts.FormContainerLayout
		singularName={"Kelas"}
		isLoading={isLoading.tambahKelas}
	>
		{mataKuliah && semester ? 
		(<>
		 <FormTambahKelas
			{...{ 
				mataKuliah
, 				semester
				}}
		 /> 
		</>)  : (<></>)}
	</Layouts.FormContainerLayout>

)}

	</Layouts.ViewContainerLayout>
  )
}
export default TambahKelasPage

